module.exports = __webpack_public_path__ + "img/middle-caicos.b54e5da7.jpg";